import { TaskTypeStatus } from '@econtractor/types';
import { useTranslation } from 'react-i18next';

interface TaskStatusBadgeProps {
    status: number;
    dateEnd?: number | null;
    /** Soft-delete: візуально показує «Видалена» замість реального статусу */
    taskDeleted?: number | boolean | null;
}

type BadgeTone = 'new' | 'inwork' | 'completed' | 'accepted' | 'cancelled' | 'reject' | 'overdue' | 'deleted';

const statusTone = (status: number): BadgeTone => {
    switch (status) {
        case TaskTypeStatus.NEW:
            return 'new';
        case TaskTypeStatus.INWORK:
            return 'inwork';
        case TaskTypeStatus.COMPLETED:
            return 'completed';
        case TaskTypeStatus.ACCEPTED:
            return 'accepted';
        case TaskTypeStatus.CANCELLED:
            return 'cancelled';
        case TaskTypeStatus.REJECT:
            return 'reject';
        default:
            return 'new';
    }
};

const toneMeta: Record<BadgeTone, { icon: string }> = {
    new: { icon: 'bi-circle' },
    inwork: { icon: 'bi-play-fill' },
    completed: { icon: 'bi-check2-all' },
    accepted: { icon: 'bi-hand-thumbs-up' },
    cancelled: { icon: 'bi-x-circle' },
    reject: { icon: 'bi-slash-circle' },
    overdue: { icon: 'bi-exclamation-circle' },
    deleted: { icon: 'bi-trash3' },
};

const TaskStatusBadge = ({
    status,
    dateEnd = null,
    taskDeleted = false,
}: TaskStatusBadgeProps) => {
    const { t } = useTranslation(['Tasks']);
    const now = Date.now();
    const isDeleted = Boolean(Number(taskDeleted));

    const isOpen =
        status !== TaskTypeStatus.COMPLETED &&
        status !== TaskTypeStatus.ACCEPTED &&
        status !== TaskTypeStatus.CANCELLED &&
        status !== TaskTypeStatus.REJECT;
    const overdue = !isDeleted && isOpen && Number(dateEnd || 0) > 0 && Number(dateEnd) < now;

    const tone: BadgeTone = isDeleted
        ? 'deleted'
        : overdue
          ? 'overdue'
          : statusTone(status);

    const label = isDeleted
        ? t('status.deleted')
        : overdue
          ? t('status.overdue')
          : t(`status.${status}`, { defaultValue: String(status) });

    return (
        <span className={`badge task-status-badge task-status-badge--${tone}`}>
            <i className={`bi ${toneMeta[tone].icon} me-1`}></i>
            {label}
        </span>
    );
};

export default TaskStatusBadge;
